import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DNA_TRAITS } from '../config/dnaSystem.js';

const DNATraitVoting = ({ onVote, disabled }) => {
  const [showTraits, setShowTraits] = useState(false);

  const handleTraitClick = (trait) => {
    if (disabled) return;
    onVote(trait);
    setShowTraits(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowTraits(!showTraits)}
        disabled={disabled}
        className={`px-4 py-2 rounded-lg transition-colors flex items-center gap-2 ${
          disabled
            ? 'bg-harmony-gray/20 text-harmony-white/30 cursor-not-allowed'
            : 'bg-harmony-blue/20 text-harmony-white/60 hover:bg-harmony-blue/30 hover:text-harmony-white'
        }`}
      >
        Vote DNA Trait
      </button>

      <AnimatePresence>
        {showTraits && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full left-0 mt-2 w-64 bg-harmony-dark-800 rounded-lg shadow-lg overflow-hidden z-50"
          >
            <div className="p-2 grid gap-1">
              {Object.entries(DNA_TRAITS).map(([key, trait]) => (
                <button
                  key={key}
                  onClick={() => handleTraitClick(key)}
                  className="w-full px-3 py-2 text-left rounded hover:bg-harmony-blue/20 transition-colors flex items-center gap-2"
                >
                  <span className="text-harmony-white/80">{trait.icon}</span>
                  <div>
                    <div className="text-harmony-white/90 font-medium">
                      {trait.name}
                    </div>
                    <div className="text-sm text-harmony-white/60">
                      {trait.description}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DNATraitVoting; 